<template>
  <div>
    <div v-if="isLoading" class="spinner-container">
      <spinner class="spinner-secction" />
    </div>
    <tabs v-else>
      <tab name="Reports" :selected="true">
        <DocumentView :documents="reports" :user="user" />
      </tab>
      <tab name="Monthly Statements">
        <DocumentView :documents="monthlys" :user="user" />
      </tab>
      <tab name="Tax Documents">
        <DocumentView :documents="taxes" :user="user" />
      </tab>
      <tab name="Transaction Notices">
        <DocumentView :documents="transactionNotices" :user="user" />
      </tab>
    </tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import tabs from '@/components/TabsComponent/Tabs';
import tab from '@/components/TabsComponent/Tab';
import spinner from '@/components/widgets/Spinner';
import DocumentView from './DocumentView';

export default {
  name: 'DocumentTabView',
  components: {
    tabs,
    tab,
    DocumentView,
    spinner,
  },
  computed: {
    ...mapState('app', [
      'user',
    ]),
  },
  data() {
    return {
      reports: [],
      monthlys: [],
      taxes: [],
      transactionNotices: [],
      isLoading: true,
    };
  },
  async beforeMount() {
    this.reports = await this.getAccountDocuments({
      accountId: this.$route.params.accountId,
      query: { documentType: 'reports' },
    });
    this.isLoading = false;
    this.getAccountDocuments({
      accountId: this.$route.params.accountId,
      query: { documentType: 'monthly' },
    }).then((monthlys) => {
      this.monthlys = monthlys;
    });
    this.getAccountDocuments({
      accountId: this.$route.params.accountId,
      query: { documentType: 'tax' },
    }).then((taxes) => {
      this.taxes = taxes;
    });
    this.getAccountDocuments({
      accountId: this.$route.params.accountId,
      query: { documentType: 'transaction' },
    }).then((transactionNotices) => {
      this.transactionNotices = transactionNotices;
    });
  },
  methods: {
    ...mapActions('account', [
      'getAccountDocuments',
    ]),
  },
};
</script>
<style scoped>
.spinner-secction {
  position: relative;
}

.spinner-container {
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// DocumentTabView.vue?feac9f76